import { render } from "./App.vue?vue&type=template&id=0e878bfc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0e878bfc&lang=css"

import exportComponent from "C:\\Work\\vscode_playground\\WeinfinderV3\\weinfinder\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__